import { render } from "./SpacesMyGroups.vue?vue&type=template&id=2a11e28d&scoped=true&ts=true"
import script from "./SpacesMyGroups.vue?vue&type=script&lang=ts"
export * from "./SpacesMyGroups.vue?vue&type=script&lang=ts"

import "./SpacesMyGroups.vue?vue&type=style&index=0&id=2a11e28d&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a11e28d"]])

export default __exports__